import React, { useState, useEffect } from 'react';
import CookieConsent from 'react-cookie-consent';
import Button from './common/Button';
import { useCookieConsent } from '../providers/CookieConsentContext';

const CookieConsentBanner: React.FC = () => {
  const {
    cookiePreferences,
    showBanner,
    showSettings,
    handleAcceptAll,
    handleRejectNonEssential,
    handleSavePreferences,
    toggleSettings,
  } = useCookieConsent();

  // Temporary state for cookie settings
  const [tempPreferences, setTempPreferences] = useState(cookiePreferences);

  // Update temp preferences when cookiePreferences changes
  useEffect(() => {
    setTempPreferences(cookiePreferences);
  }, [cookiePreferences]);

  const handleSaveSettings = () => {
    handleSavePreferences(tempPreferences);
    toggleSettings();
  };

  if (!showBanner && !showSettings) return null;

  return (
    <>
      <CookieConsent
        location="bottom"
        buttonText="Accept All"
        declineButtonText="Reject Non-Essential"
        enableDeclineButton
        onAccept={handleAcceptAll}
        onDecline={handleRejectNonEssential}
        style={{
          background: '#fff',
          color: '#000',
          boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
          zIndex: 999,
        }}
        buttonStyle={{
          background: '#2563eb',
          color: '#fff',
          fontSize: '14px',
          borderRadius: '4px',
          padding: '8px 16px',
          marginLeft: '10px',
          order: 3,
        }}
        declineButtonStyle={{
          background: '#e5e7eb',
          color: '#374151',
          fontSize: '14px',
          borderRadius: '4px',
          padding: '8px 16px',
          marginLeft: '10px',
          order: 2,
        }}
        contentStyle={{ flex: '1 0 auto', margin: '15px' }}
        buttonWrapperClasses="flex flex-row items-center justify-end flex-wrap"
        extraCookieOptions={{ customizeButton: true }}
        ButtonComponent={({ children, ...props }: any) => {
          if (
            children === 'Accept All' ||
            children === 'Reject Non-Essential'
          ) {
            return <button {...props}>{children}</button>;
          }
          return null;
        }}
        overlayClasses="fixed bottom-0 left-0 w-full"
      >
        <div className="flex items-center w-full justify-between">
          <span style={{ color: '#374151' }}>
            We use cookies to enhance your experience. By continuing to visit
            this site you agree to our use of cookies.
          </span>
          <div className="flex items-center">
            <button
              onClick={toggleSettings}
              className="px-4 py-2 bg-gray-200 text-gray-800 hover:bg-gray-300 rounded-md transition-colors text-sm mr-2"
              style={{ order: 1 }}
            >
              Customize Settings
            </button>
          </div>
        </div>
      </CookieConsent>

      {showSettings && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
          <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full">
            <h2 className="text-xl font-semibold mb-4">Cookie Settings</h2>
            <div className="space-y-4">
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={true}
                  disabled
                  className="cursor-not-allowed"
                />
                <label className="text-sm">
                  Essential Cookies (Required for the website to function)
                </label>
              </div>
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={tempPreferences.analytics}
                  onChange={(e) =>
                    setTempPreferences((prev) => ({
                      ...prev,
                      analytics: e.target.checked,
                    }))
                  }
                />
                <label className="text-sm">
                  Analytics Cookies (Help us improve our website)
                </label>
              </div>
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={tempPreferences.marketing}
                  onChange={(e) =>
                    setTempPreferences((prev) => ({
                      ...prev,
                      marketing: e.target.checked,
                    }))
                  }
                />
                <label className="text-sm">
                  Marketing Cookies (Help us provide relevant advertisements)
                </label>
              </div>
            </div>
            <div className="flex justify-end gap-2 mt-6">
              <Button
                onClick={toggleSettings}
                className="bg-gray-200 text-gray-800 hover:bg-gray-300"
              >
                Cancel
              </Button>
              <Button
                onClick={handleSaveSettings}
                className="bg-blue-500 text-white hover:bg-blue-600"
              >
                Save Settings
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieConsentBanner;
